<template>
  <btn-zzim-template
    :title="titleStr"
    :wrapper-class="'check-like ' + getIconStyle"
    :check-state="value"
    :toggle-fn="toggle"
  ></btn-zzim-template>
</template>
<script>
  import _ from 'lodash'
  import BtnZzimTemplate from '@/components/button/BtnZzimTemplate'
  import ZzimMixIn from '@/mixins/zzim.mixin'
  import { mapMutations } from 'vuex'
  import { CellEventMapper } from '@/common/utils/gnb.fp'
  import { apiRequest } from '@/common/utils/request.common'
  import { showRequiredLoginPopup } from '@/common/utils/common'
  import cookie from '@/common/utils/cookie'

  export default {
    name: 'BtnZzimWithEvent',
    components: { BtnZzimTemplate },
    mixins: [ZzimMixIn],
    props: {
      eventList: {
        type: Array,
      },
      isOn: {
        type: String,
        default: 'n',
      },
      iconOnly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        value: false,
        titleStr: '',
        contentsType: '',
      }
    },
    created() {
      this.init()
    },
    methods: {
      ...mapMutations(['showLoginPopup']),
      toggle(newState) {
        if (this.isMypooq) {
          if (showRequiredLoginPopup()) return
        } else if (cookie.getCredential() === 'none') {
          this.showLoginPopup()
          return
        } else if (cookie.isWavveOn()) {
          this.$events.$emit(
            'OPEN_PPV_TOAST',
            () => {},
            '웨이브온에서는 지원하지 않는 기능입니다.',
          )
          return
        }
        const { onZzim, offZzim } = CellEventMapper(this.eventList)
        const event = newState ? onZzim : offZzim

        apiRequest({
          url:
            'https://' + _.get(event, 'url', '').replace(location.protocol, ''),
          method: _.get(event, 'method', ''),
          data: _.get(event, 'bodyjson', {}),
        }).then(({ data }) => {
          const resultCode = _.get(data, 'resultcode', '200')
          if (resultCode === '500') {
            const message = _.get(
              data,
              'resultmessage',
              '잠시 후 다시 시도해 주세요',
            )
            this.$events.$emit('OPEN_PPV_TOAST', () => {}, message)
          } else {
            this.value = newState

            const { messageAdd, messageDelete } = this.getResultMessage(
              this.contentsType,
            )
            if (newState) {
              this.$events.$emit('OPEN_PPV_TOAST', () => {}, messageAdd)
            } else {
              this.$events.$emit('OPEN_PPV_TOAST', () => {}, messageDelete)
            }
          }
        })
      },

      getContentType() {
        const { onZzim } = CellEventMapper(this.eventList)
        this.contentsType =
          onZzim?.bodyjson?.contenttype || onZzim?.bodyjson?.type || ''
      },
      init() {
        this.getContentType()
        this.titleStr = this.iconOnly ? '' : this.title
        this.value = this.isOn === 'y'
      },
    },
  }
</script>
